function o(r) {
  var e = -1, a = Array(r.size);
  return r.forEach(function(n, t) {
    a[++e] = [t, n];
  }), a;
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_mapToArray.js
// module id = 1538
// module chunks = 67